import { useMemo } from "react";
import { PhoneOut, Mail, Whatsapp, UserPlus } from "@repo/icons";
import { generateContactUrl } from "@repo/lib/src/helpers/contact-url";
import { graphql } from "@repo/graphql-types/gql";
import { useFragment, type FragmentType } from "@repo/graphql-types";
import { Link, useRouteContext } from "@tanstack/react-router";
import { PatientDetailHeaderActionItem } from "@/components/patient-detail/patient-detail-header-action-item";

export const PatientDetailHeaderActionsFragment = graphql(/* GraphQL */ `
  fragment PatientDetailHeaderActionsFragment on pacientes {
    telefone
    email
    codPaciente
  }
`);

interface PatientDetailHeaderActionsProps {
  data: FragmentType<typeof PatientDetailHeaderActionsFragment>;
}

export const PatientDetailHeaderActions = ({
  data,
}: PatientDetailHeaderActionsProps): JSX.Element => {
  const patient = useFragment(PatientDetailHeaderActionsFragment, data);
  const { telefone, email, codPaciente } = patient;

  function openUrl(url: string, openOnNewTab = false): void {
    if (!url) return;

    if (!openOnNewTab) {
      window.open(url);
      return;
    }

    window.open(url, "_blank")?.focus();
  }

  const { flags } = useRouteContext({ strict: false });
  const showNewPatientLayout = useMemo(
    () => flags["exibe-nova-tela-de-paciente"],
    [flags],
  );

  return (
    <div className="flex flex-row justify-between gap-4">
      {!showNewPatientLayout ? (
        <div className="w-full">
          <Link to="/recommendation/" search={{ patientId: codPaciente }}>
            <PatientDetailHeaderActionItem Icon={UserPlus} />
          </Link>
        </div>
      ) : null}
      <div className="w-full">
        <PatientDetailHeaderActionItem
          Icon={PhoneOut}
          onClick={() => openUrl(generateContactUrl(telefone, "phone"))}
        />
      </div>
      <div className="w-full">
        <PatientDetailHeaderActionItem
          Icon={Mail}
          onClick={() => openUrl(generateContactUrl(email ?? "", "email"))}
        />
      </div>
      <div className="w-full">
        <PatientDetailHeaderActionItem
          Icon={Whatsapp}
          onClick={() => openUrl(generateContactUrl(telefone, "whatsapp"), true)}
        />
      </div>
    </div>
  );
};
